export const FILTER_SELECT_PLACEHOLDER = 'Select an option';
export const DEFAULT_SEARCH_PLACEHOLDER = 'Search';
export const FILTER_TYPE = {
  text: 'text',
  select: 'select'
};
export const APPLY_FILTER_BUTTON_TEXT = 'Apply filter';
export const FILTER_BOX_BUTTON_TEXT = 'Filters';
export const FILTER_BOX_POPOVER_ID = 'on-asset-filter';
export const PREVIEW_MODAL_TITLE = 'Details';
export const PREVIEW_MODAL_LABEL_TITLE = 'Title';
export const PREVIEW_MODAL_LABEL_FILE_NAME = 'File name';
export const PREVIEW_MODAL_CANCEL_BUTTON_TEXT = 'Cancel';
export const PREVIEW_MODAL_INSERT_BUTTON_TEXT = 'Insert selection';
export const FILE_TYPE = {
  video: 'video',
  audio: 'audio',
  image: 'image',
  office: 'office',
  pdf: 'pdf',
  archive: 'compressed_archive'
};
export const ENTER_KEY = 'Enter';
export const SEARCH_BAR = {
  placeholder: 'Search in widen library',
  label: 'Content',
  inputName: 'content',
  results: 'Results:',
  searchOnWiden: 'Search on Widen',
  iconTooltipText: 'Search'
};
export const WIDEN_MODAL_TITLE = 'Widen Search Connector';
export const WIDEN_MODAL_HEADER_TITLE_PREFIX = 'Start ';
export const WIDEN_MODAL_HEADER_TITLE_SUFFIX = 'your search';
export const WIDEN_MODAL_ENTRIES_FOUND_TITLE = entriesCount => `${entriesCount} entries found`;
export const WIDEN_MODAL_ASSET_TITLE_ID = 'asset-dialog-title';
export const WIDEN_MODAL_CANCEL_BUTTON_TEXT = 'Cancel';
export const WIDEN_MODAL_CANCEL_BUTTON_ID = 'app.components.Button.cancel';
export const WIDEN_MODAL_FINISH_BUTTON_TEXT = 'Finish';
export const WIDEN_MODAL_FINISH_BUTTON_ID = 'form.button.finish';
export const ASSET_CARD_INLINE_STYLE = {
  width: '240px',
  cursor: 'pointer'
};
export const ASSET_CARD_EYE_ICON_TOOLTIP_TEXT = 'Preview';
export const ASSET_CARD_IMAGE_URL_BASE = 'https://cerifi.widen.net/content/';
export const ASSET_CARD_IMAGE_URL_PARAM = '.jpeg?w=2048';
export const WIDEN_SEARCH_BOX_MODAL_INITIAL_STATE = {
  item: null,
  id: '',
  filetype: '',
  preview: '',
  title: '',
  fileName: ''
};
export const WIDEN_SEARCH_BOX_PREFILTERS_TYPE = 'file-type';
export const WIDEN_SEARCH_BOX_PREFILTERS_METADATA = {
  query: 'ft'
};
export const WIDEN_SEARCH_BOX_ERROR_MESSAGE = 'Unable to fetch assets, please contact the system administrator.';
export const WIDEN_SEARCH_BOX_NO_RESULTS_MESSAGE = 'No results found.';
export const WIDEN_SEARCH_BOX_LOADING_MESSAGE = 'Loading';
export const ASSET_KEYS = {
  external_id: 'external_id',
  filename: 'filename',
  id: 'id',
  display_name: 'displayName',
  altText: 'altText'
};